import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR, GET_STORES, DELETE_STORE, DELETE_STORE_SUCCESS, DELETE_STORE_FAIL,
} from "./actionType";

// common success
export const apiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const apiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getStores = (params = {}) => {
  console.log('get Stores')
  return ({
  type: GET_STORES,
  payload: params,
})};

export const deleteStore = store => ({
  type: DELETE_STORE,
  payload: store,
});

export const deleteStoreSuccess = product => ({
  type: DELETE_STORE_SUCCESS,
  payload: product,
});

export const deleteStoreFail = error => ({
  type: DELETE_STORE_FAIL,
  payload: error,
});
